import GetQwotedCTA from "./GetQwotedCTA";

export default GetQwotedCTA;
